module.exports = __webpack_public_path__ + "img/instagram.e8aa6da2.svg";